module.exports = __webpack_public_path__ + "static/media/tablet.af0fdbc4.png";